import { render } from "./VideoTypeCard.vue?vue&type=template&id=5bce44c4&scoped=true&ts=true"
import script from "./videoTypeCardHelper.ts?vue&type=script&lang=ts"
export * from "./videoTypeCardHelper.ts?vue&type=script&lang=ts"

import "./VideoTypeCard.vue?vue&type=style&index=0&id=5bce44c4&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bce44c4"]])

export default __exports__